import { useState, useEffect } from 'react';
import './StatisticsData.css';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import  { checkBookingWithMailOnYear, getDataBookingByRequest } from '../../../api/statistics';
import { coverBranchIDToFullName, coverNameToID } from '../../../utils/Branch/SupportBranch';
import * as companyAPI from '../../../api/company';
import { useSelector, useDispatch } from 'react-redux';
import { unitsAction } from '../../../redux/actions';

const LIST_NAME_OTA = ["booking.com", "agoda", "expedia", "hafh", "trip.com", "rakuten", "traveloka"];

const thStyle = {
    padding: '12px 10px',
    borderBottom: '1px solid #696767',
    color: '#333',
    fontWeight: '600',
    textAlign: 'center',
};

const tdStyle = {
    padding: '12px 10px',
    borderBottom: '1px solid #a3a3a3',
    color: '#444',
    verticalAlign: 'middle',
    textAlign: 'center',
};

const trStyle = {
    transition: 'background-color 0.2s',
    textAlign: 'center',
};

const LIST_COLOR_TEAM = {
    vat: ['red'],
    waiting: ['black'],
    hotel: ['gray'],
    OTA: [""],
    normal1:["#ff5b5b","#ff9900","#ffff00","#00ff00","#00ffff","#0000ff","#9900ff","#ff00ff"], //"#ff0000",
    normal2:["#f4cccc","#fce5cd","#fff2cc","#d9ead3","#d0e0e3","#cfe2f3","#d9d2e9","#ead1dc"],
    normal3:["#ea9999","#f9cb9c","#ffe599","#b6d7a8","#a2c4c9","#9fc5e8","#b4a7d6","#d5a6bd"],
    normal4:["#e06666","#f6b26b","#ffd966","#93c47d","#76a5af","#6fa8dc","#8e7cc3","#c27ba0"],
    normal5:["#ce3636","#e69138","#f1c232","#6aa84f","#45818e","#3d85c6","#674ea7","#a64d79"], //
    normal6:["#990000","#b45f06","#bf9000","#38761d","#134f5c","#0b5394","#351c75","#741b47"],
    normal7:["#660000","#783f04","#7f6000","#274e13","#0c343d","#073763","#20124d","#4c1130"]
};

const LIST_OTA_BRANCH = {
    "1"  : ["gray","gray","gray"],
    "3"  : ["#0000ff","#0000ff","#0000ff"],    
    "4"  : ["gray","gray","gray"],
    "7"  : ["#ff9900","#00ff00","#9900ff","#ffd966","#ffd966"],
    "8"  : ["#00ff00","#00ffff","#ff00ff"],
    "9"  : ["gray","gray","gray"],
    "11" : ["#00ff00", "#00ff00", "#00ff00"], 
    "12" : ["#00ff00", "#ff00ff","#0000ff"],//#0000ff  //#7f6000
    "13" : ["#ff9900","#00ff00","#9900ff","#00ffff","#0000ff"],
    "15" : ["#00ff00", "#00ffff","#ff00ff", "#9900ff"],
    "16" : ["#00ff00","#ff00ff","#0000ff", "#00ffff"],
    "97" : [],
    "98" : [],
    "99" : [],
}

const StatisticsData = () => {
    // Company filter
    const [companyYear, setCompanyYear] = useState(new Date().getFullYear());
    const [companyName, setCompanyName] = useState('');
    const [inputCompanyName, setInputCompanyName] = useState('');
    const [listSuggestCompany, setListSuggestCompany] = useState([]);
    
    // Mail filter
    const [mailYear, setMailYear] = useState(new Date().getFullYear());
    const [mailValue, setMailValue] = useState('');
    const [mailIsExactMatch, setMailIsExactMatch] = useState(false);
    
    // Line filter
    const [lineYear, setLineYear] = useState(new Date().getFullYear());
    const [lineMonth, setLineMonth] = useState(new Date().getMonth() + 1);

    // Line filter
    const [colorYear, setColorYear] = useState(new Date().getFullYear());
    const [colorMonth, setColorMonth] = useState(new Date().getMonth() + 1);
    
    // OTA filter
    const [otaYear, setOtaYear] = useState(new Date().getFullYear());
    const [otaMonth, setOtaMonth] = useState(new Date().getMonth() + 1);
    const [selectedOTAChannel, setSelectedOTAChannel] = useState('ALL');
    const [selectedMultiBranch, setSelectedMultiBranch] = useState('ALL');
    
    // Custom filter
    const [customYear, setCustomYear] = useState(new Date().getFullYear());
    const [customMonth, setCustomMonth] = useState(new Date().getMonth() + 1);
    const [customValue, setCustomValue] = useState('');

    const [listOTAType, setListOTAType] = useState([]);
    const [summaryOTABranch, setSummaryOTABranch] = useState([]);
    const [listBranch, setListBranch] = useState([]);
    
    const [bookingData, setBookingData] = useState([]);
    const [subBookingData, setSubBookingData] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('company');

    const [openColor, setOpenColor] = useState(false);
    const [color, setColor] = useState("black");

    const auth = useSelector(state => state.auth);
    const { branchID, role , area } = auth.user;
    const token = useSelector(state => state.token);
    const dispatch = useDispatch();

    useEffect(() => {
        if(branchID) {
            LIST_COLOR_TEAM["ota"] = LIST_OTA_BRANCH[branchID] || [];
        }
    },[branchID]);

    // Build period string for API: either "YYYY" (all months) or "YYYY-MM"
    const buildPeriod = (year, month) => {
        if (String(month).toLowerCase().includes('all')) return String(year);
        const mm = typeof month === 'number' ? String(month).padStart(2, '0') : String(month).padStart(2, '0');
        return `${year}-${mm}`;
    }

    // Fetch booking data theo tháng
    const fetchBookingData = async (type) => {
        try {
            setLoading(true);
            setError(null);



            if (type === 'company') {
                // Call API for company search
                if (!companyName.trim()) {
                    setError('Please enter company name');
                    setLoading(false);
                    return;
                }
                
                const response = await checkBookingWithMailOnYear({
                    company: companyName,
                    year: "" + mailYear,
                    branchID,
                    role, 
                    area, 
                    accuracy: mailIsExactMatch
                }, "stayOnYearCompany", token);

                setBookingData(response.data.dataReturn || []);

            } else if (type === 'mail') {
                // Call API for email search
                if (!mailValue.trim()) {
                    setError('Please enter email');
                    setLoading(false);
                    return;
                }
                const response = await checkBookingWithMailOnYear({
                    mail: mailIsExactMatch ? mailValue : mailValue.includes("@") ? mailValue : "@" + mailValue,
                    year: "" + mailYear,
                    branchID,
                    role, 
                    area, 
                    accuracy: mailIsExactMatch
                }, "stayOnYear", token);
                
                setBookingData(response.data.dataReturn || []);
            } else if (type === 'color') {
                // Call API for email search
                if (color === "black") {
                    setError('Please select color');
                    setLoading(false);
                    return;
                }
                const response = await checkBookingWithMailOnYear({
                    color: color, //mailIsExactMatch ? mailValue : mailValue.includes("@") ? mailValue : "@" + mailValue,
                    year: "" + colorYear,
                    month: "" + colorMonth,
                    branchID,
                    role, 
                    area, 
                    accuracy: mailIsExactMatch
                }, "stayOnYearColor", token);
                
                setBookingData(response.data.dataReturn || []);
            } else if (type === 'line' || type === "custom") {
                console.log("vo here check line / custom")
                let period;
                if(lineMonth === "All Month") {
                    period =lineYear;
                } else period = buildPeriod(lineYear, lineMonth);
                
                const response = await getDataBookingByRequest(role === 7 ? "all" :branchID, { 
                    value : type === "line" ? "LINE" : customValue,
                    branchID,
                    role, 
                    area, 
                }, period, token);

                console.log("response", response)
                
                if(role > 5) {
                    const allBranchDataOTa = response.data.flatMap((item, index) => {
                        // Bỏ qua phần tử đầu tiên hoặc các item không có detail hợp lệ
                        if (index === 0 || !item.detail || item.detail.length === 0) {
                            return []; 
                        }
                        return item.detail;
                    });
                    setBookingData(allBranchDataOTa);
                    setListBranch(response.data.map(item => item.branch));

                } else setBookingData(response.data[1].detail || []);
                setSubBookingData(response.data.map(item => ({totalBooking: item.totalBooking, totalNight: item.totalNight, branch: item.branch})));

            } else if (type === 'ota') {
                // Call API for OTA search
                const period = buildPeriod(otaYear, otaMonth);
                const response = await getDataBookingByRequest(role === 7 ? "all" :branchID, { 
                    value : "OTA",
                    branchID,
                    role, 
                    area, 
                }, period, token);

                if(role > 5) {
                    setSummaryOTABranch(response.data.map(item => ([
                        ...(item.summaryByOTA || []), 
                        {totalBooking: item.totalBooking, totalNight: item.totalNight, _id: "Total"}
                    ])));
                    setListBranch(response.data.map(item => item.branch));
                } else {
                    setSummaryOTABranch(response.data.map(item => ([
                        ...(item.summaryByOTA || []), 
                        {totalBooking: item.totalBooking, totalNight: item.totalNight, _id: "Total"}
                    ])));  
                }

               setListOTAType(response.data[0].summaryByOTA.map(item => item._id));
             
               if(role === 6 || role === 7) {
                const allBranchDataOTa = response.data.map(item => item.detailBookings).flat();
                setBookingData(allBranchDataOTa);
               } else setBookingData(response.data[1].detailBookings || []);

               setSubBookingData([...response.data[0].summaryByOTA, {totalNight: response.data[0].totalNight, totalBooking: response.data[0].totalBooking, _id: "Total"}]);

                //params = { ...params, channel: 'ota', year: "" + otaYear, month: "" + otaMonth };
            } else if (type === 'custom2') {
                // Call API for custom search
                console.log("vo here check custom2")
                if (!customValue.trim()) {
                    setError('Please enter search keyword');
                    setLoading(false);
                    return;
                }
                const period = buildPeriod(customYear, customMonth);
                const response = await getDataBookingByRequest(role === 7 ? "all" :branchID, { value : customValue}, period, token);
                setBookingData(response.data[0] || []);
            }

        } catch (err) {
            console.log("err", err)
            setError('Lỗi khi tải dữ liệu: ' + err.message);
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const exportToExcel = async () => {
        // 1. Khởi tạo Workbook và Worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Booking Report');

        const blackBorder = {
            top: { style: 'thin', color: { argb: 'FF000000' } },
            left: { style: 'thin', color: { argb: 'FF000000' } },
            bottom: { style: 'thin', color: { argb: 'FF000000' } },
            right: { style: 'thin', color: { argb: 'FF000000' } }
        };

        // 2. Xác định các cột và Tiêu đề (Headers) tùy thuộc vào Tab đang active
        let headers = [];
        if (activeTab === "line" || activeTab === "custom" || activeTab === "ota") {
            headers = ["No.", "Booking ID", "Room", activeTab === "ota" ? "OTA Name" : "Discount", "Check-in", "Check-out", "Overlap Nights", "Requests / Notes"];
        } else {
            headers = ["No.", "Booking ID", "Branch", "Customer Name", "Email", "Payment", "Check-in", "Check-out", "Nights", "Room", "Price"];
        }

        // Thêm dòng header vào worksheet
        const headerRow = worksheet.addRow(headers);

        // Định dạng cho dòng Header (Nền xám nhạt, chữ đậm, căn giữa)
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF00' } // Màu nền #f4f4f4 giống CSS của bạn
            };
            cell.font = {
                name: 'Arial',
                size: 11,
                bold: true,
                color: { argb: 'FF333333' }
            };  
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
            cell.border = blackBorder;
        });

        // 3. Chuẩn bị và thêm dữ liệu các hàng (Rows)
        // Lọc dữ liệu y hệt như lúc bạn render trên table
        const filteredData = bookingData.filter(item => {
            if (activeTab === "ota" || activeTab === "line" || activeTab === "custom") {
                if (selectedOTAChannel !== 'ALL' && (!item.otaName || item.otaName.toLowerCase() !== selectedOTAChannel.toLowerCase())) {
                    return false;
                }
                if (selectedMultiBranch !== 'ALL') {
                    const branchToFilter = listBranch[selectedMultiBranch];
                    if (Number(item.booking_id.slice(0, 2)) !== branchToFilter) {
                        return false;
                    }
                }
            }
            return true;
        });

        // Đổ dữ liệu vào hàng
        filteredData.forEach((item, index) => {
            let rowData = [];
            if (activeTab === "line" || activeTab === "custom" || activeTab === "ota") {
                rowData = [
                    index + 1,
                    item.booking_id,
                    item.roomSelect,
                    activeTab === "ota" ? item.otaName?.toUpperCase() : `${item.discount}% OFF`,
                    formatDate(item.checkin),
                    formatDate(item.checkout),
                    item.overlapNights,
                    item.request1
                ];
            } else {
                rowData = [
                    index + 1,
                    item.boooking_id,
                    item.branch,
                    item.name,
                    item.mail,
                    activeTab === "ota" ? item.otaName : item.payment,
                    item.checkin,
                    item.checkout,
                    item.nights,
                    item.roomSelect,
                    // Để lưu giá trị dạng số vào Excel giúp tính toán được (Sum, Average...)
                    item.price ? parseInt(item.price) : 0 
                ];
            }

            const dataRow = worksheet.addRow(rowData);

            // Định dạng căn chỉnh và font cho từng ô dữ liệu
            dataRow.eachCell((cell, colNumber) => {
                cell.font = { name: 'Arial', size: 10 };
                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                
                // Nếu là cột Price (ở tab thường là cột số 11), định dạng hiển thị tiền tệ VNĐ
                if (activeTab !== "line" && activeTab !== "custom" && activeTab !== "ota" && colNumber === 11) {
                    cell.numFmt = '#,##0" đ"';
                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                }
            });
        });

        // 4. Tự động điều chỉnh độ rộng của cột (Auto-fit column width)
        worksheet.columns.forEach(column => {
            let maxLen = 0;
            column.eachCell({ includeEmpty: true }, cell => {
                const cellLen = cell.value ? cell.value.toString().length : 0;
                if (cellLen > maxLen) maxLen = cellLen;
            });
            column.width = maxLen < 12 ? 12 : maxLen + 3; // Tối thiểu rộng 12, tối đa theo độ dài data + padding
        });

        // 5. Xuất file và kích hoạt download qua FileSaver
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `booking_report_${activeTab}_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    // Hàm tìm kiếm công ty (lấy từ guestInformationDetails.jsx)
    const onChangeFindCompany = (value) => {
        dispatch(unitsAction.delay());
        dispatch(unitsAction.delay());
        dispatch(unitsAction.delay());
        if (value.length >= 3) {
            const findCompany = async () => {
                const findCompanyResults = await companyAPI.findCompanyByRequest("quick_name", value, token);
                if (findCompanyResults) { 
                    setListSuggestCompany(findCompanyResults.data); 
                }
            }
            findCompany();
        } else {
            setListSuggestCompany([])
        }
    };

    // Hàm xử lý khi input company name thay đổi
    const onChangeInputCompany = (value) => {
        setInputCompanyName(value);
        setCompanyName(value);
        onChangeFindCompany(value);
    };

    // Render danh sách công ty gợi ý
    const renderSuggestCompany = () => {
        let result = [];
        if (listSuggestCompany.length > 0) {
            listSuggestCompany.forEach((company, index) => {
                result.push(
                    <div 
                        key={index}
                        style={{
                            cursor: 'pointer',
                            padding: '8px 12px',
                            borderBottom: index !== listSuggestCompany.length - 1 ? '1px solid #ddd' : "",
                            backgroundColor: '#fff',
                            transition: 'background-color 0.2s'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#fff'}
                        onClick={() => {
                            setInputCompanyName(company.name);
                            setCompanyName(company.name);
                            setListSuggestCompany([]);
                        }}
                    >
                        {company.name}
                    </div>
                );
            });
        }
        return result;
    };

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 5 }, (_, i) => currentYear - i);
    const months = Array.from({ length: 12 }, (_, i) => i + 1);

    // Hàm format định dạng tiền tệ (VND) cho dễ nhìn hơn
    const formatPrice = (priceString) => {
        return parseInt(priceString).toLocaleString('vi-VN') + ' đ';
    };

    const exportToCSV = () => {
        // Định nghĩa tiêu đề cột
        const headers = ["No.", "Branch", "Customer Name", "Email", "Payment", "Check-in", "Check-out", "Nights", "Room", "Price",];
        
        // Chuyển đổi dữ liệu json thành các hàng dòng text ngăn cách bằng dấu phẩy
        const rows = bookingData.map(item => [
            item.no,
            // item.boooking_id,
            item.branch,
            `"${item.name}"`, // Bọc ngoặc kép để tránh lỗi nếu tên có dấu phẩy
            item.mail,
            item.payment,
            item.checkin,
            item.checkout,
            item.nights,
            item.roomSelect,
            item.price,
            // item.link
        ]);

        // Gộp hàng đầu và dữ liệu thành 1 mảng lớn
        const csvContent = [headers, ...rows].map(e => e.join(",")).join("\n");
        
        // Tạo mã UTF-8 BOM để Excel hiển thị được tiếng Việt có dấu (như HỒ MINH TOÀN)
        const blob = new Blob(["\ufeff" + csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        
        // Tạo thẻ a ẩn để kích hoạt download
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `booking_report_${new Date().toISOString().slice(0,10)}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Format ngày ngắn gọn (YYYY-MM-DD)
    const formatDate = (isoString) => {
        if (!isoString) return '';
        return isoString.split('T')[0];
    };

    function changeContentRequest1GuestOTAwithBranch(index) {

        function selectText(array) {
            if(index > array.length - 1) return "";
            return array[index]
        }

        switch(Number(branchID)) {
            case 1: case 4: case 9:  return selectText([ "AGODA Booking ID", "Trip.com Booking ID", "HafH Booking ID",]);
            case 3: return selectText(["EXPEDIA", "BOOKING.COM", "AGODA"]);
            case 7: return selectText(["EXPEDIA", "BOOKING.COM", "AGODA","RAKUTEN", "HafH"]);
            case 8: return selectText(["EXPEDIA'S GUEST", "BOOKING.COM'S GUEST", "AGODA'S GUEST"]);
            case 11: return selectText(["Expedia prepaid Booking ID", "Agoda Booking ID", "Trip.com prepaid Booking ID"]);
            case 12: return selectText(["EXPEDIA GUEST", "BOOKING.COM GUEST", "AGODA GUEST"]);
            case 13: return selectText(["EXPEDIA", "BOOKING.COM", "AGODA", "RAKUTEN", "TRIP.COM"]);
            case 15: return selectText(["EXPEDIA GUEST", "BOOKING.COM GUEST", "AGODA GUEST", "TRIP.COM GUEST"]);
            case 16: return selectText(["EXPEDIA", "BOOKING.COM", "AGODA", "TRIP.COM"]);
            default: return "";
        }
    }

    function renderTotalBookingLine() {
        let result = [];
        if(activeTab === "line" || activeTab === "custom") {
            if(subBookingData.length > 0) {
              //  console.log("subBookingData", subBookingData)
                subBookingData.sort((a, b) => {
                if (a.branch === "ALL") return -1;
                if (b.branch === "ALL") return 1;
                return b.totalNight - a.totalNight;
                    }).forEach((item, index) => {
                        if(index === 0) result.push(<h4 key={index} >Total Booking: {item.totalBooking} <div>({item.totalNight} nights)</div></h4>);
                        else if (role > 5) result.push(<h4 key={index} className="ml-4">
                            <font color="#482979">AZ{coverNameToID(item.branch)} </font>: {item.totalBooking} <div>({item.totalNight} nights)</div>
                            </h4>);
                    })
            }
        }

        return result;
    }

    function renderListColor(list, type) {
        var result = [];

        function changeMiniText(text) {
            if(text.includes("expe")) return "Exp";
            else if(text.includes("hafh")) return "HafH";
            else if(text.includes("agoda")) return "Ago";
            else if(text.includes("trip")) return "Trip";
            else if(text.includes("rakuten")) return "Rkt";
            else if(text.includes("book")) return "Bk";
        }

        function changeFullName(text) {
            if(text.includes("expe")) return "EXPEDIA";
            else if(text.includes("hafh")) return "HafH";
            else if(text.includes("agoda")) return "AGODA";
            else if(text.includes("trip")) return "TRIP.COM";
            else if(text.includes("rakuten")) return "RAKUTEN";
            else if(text.includes("book")) return "BOOKING.COM";
        }

        if (list.length > 0) {
            list.forEach((color, index) => {
                const noteKey = changeContentRequest1GuestOTAwithBranch(index);

                result.push(
                    <div 
                        key={index}
                        style={{ position: "relative", display: "inline-block" }}
                    >
                        {/* tooltip */}
                        {type === "OTA" && (
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-30px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    backgroundColor: "black",
                                    color: "white",
                                    padding: "3px 6px",
                                    borderRadius: "4px",
                                    fontSize: "11px",
                                    whiteSpace: "nowrap",
                                    opacity: 0,
                                    pointerEvents: "none",
                                    transition: "opacity 0.2s",
                                }}
                                className="tooltip-ota"
                            >
                                {changeFullName(String(noteKey).toLowerCase())}
                            </div>
                        )}

                        <span
                            style={{
                                backgroundColor: color,
                                width: '35px',
                                height: '100%',
                                cursor: 'pointer',
                                textAlign:"center",
                                textShadow: `
                                    -0.5px -0.5px 0 white,
                                    0.5px -0.5px 0 white,
                                    -0.5px  0.5px 0 white,
                                    0.5px  0.5px 0 white`,
                                fontWeight: '600',
                                border: '0.8px solid white',
                                display: "inline-block",
                            }}
                            onMouseEnter={(e) => {
                                const tooltip = e.currentTarget.parentNode.querySelector(".tooltip-ota");
                                if (tooltip) tooltip.style.opacity = 1;
                            }}
                            onMouseLeave={(e) => {
                                const tooltip = e.currentTarget.parentNode.querySelector(".tooltip-ota");
                                if (tooltip) tooltip.style.opacity = 0;
                            }}
                            onClick={() => {
                               // onChangeChildren(color, "color");
                                setColor(color);
                                setOpenColor(false);
                            }}
                        >
                            {type === "OTA" ? changeMiniText(String(noteKey).toLowerCase()) : ""}
                        </span>
                    </div>
                );
            })
        }
        return result;
    }

    function renderTeamColor() {
        var result = [];
        const listKey = Object.keys(LIST_COLOR_TEAM);

        if(LIST_OTA_BRANCH[""+branchID].length > 0) {
            listKey.forEach((label) => {
                result.push(<div className="d-flex">
                    <div style={{ width: '75px', border: '0.8px solid black', fontSize:'1.3rem' }}>{label.toUpperCase()}</div>
                    <div className="d-flex flex-wrap">
                        {label === "OTA" ? renderListColor(LIST_OTA_BRANCH[""+branchID],"OTA") : renderListColor(LIST_COLOR_TEAM[label])}
                    </div>
                </div>)
            });
        } else {
            listKey.forEach((label) => {
                if(label !== "OTA") {
                    result.push(<div className="d-flex">
                    <div style={{ width: '75px', border: '0.8px solid black', fontSize:'1.3rem' }}>{label.toUpperCase()}</div>
                    <div className="d-flex flex-wrap">
                        {renderListColor(LIST_COLOR_TEAM[label], "Normal")}
                    </div>
                </div>)
                }
            });
        }

        return result;
    }

    return (
        <div className="statistics-data-container">
            <h1>📊 Booking Statistics</h1>

            {/* Tab Navigation */}
            <div className="filter-type-section">
                <h3>Select Search Type</h3>
                <div className="filter-type-buttons">
                    <button 
                        className={`filter-btn ${activeTab === 'company' ? 'active' : ''}`}
                        onClick={() => {
                            setBookingData([]);
                            setActiveTab('company');
                        }}>
                        🏢 By Company
                    </button>
                    <button 
                        className={`filter-btn ${activeTab === 'mail' ? 'active' : ''}`}
                        onClick={() => {
                            setBookingData([]);
                            setActiveTab('mail');
                        }}>
                        📧 By Mail
                    </button>
                    <button 
                        className={`filter-btn ${activeTab === 'line' ? 'active' : ''}`}
                        onClick={() => {
                            setBookingData([]);
                            setActiveTab('line');

                        }}>
                        📱 By Line
                    </button>
                    <button 
                        className={`filter-btn ${activeTab === 'ota' ? 'active' : ''}`}
                        onClick={() => {
                            setBookingData([]);
                            setActiveTab('ota');
                        }}>
                        🌐 By OTA
                    </button>
                    <button 
                        className={`filter-btn ${activeTab === 'color' ? 'active' : ''}`}
                        onClick={() => {
                            setBookingData([]);
                            setActiveTab('color');
                        }}>
                        ⚙️ By Color
                    </button>
                    <button 
                        className={`filter-btn ${activeTab === 'custom' ? 'active' : ''}`}
                        onClick={() => {
                            setBookingData([]);
                            setActiveTab('custom');
                        }}>
                        ⚙️ Custom Other1
                    </button>
                </div>
            </div>

            {/* Company Search Tab */}
            {activeTab === 'company' && (
                <div className="search-tab-section">
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        gap: '15px', 
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        padding: '4px'
                    }}>
                        <div className="filter-group">
                            <label>Year:</label>
                            <select value={companyYear} onChange={(e) => setCompanyYear(Number(e.target.value))}>
                                {years.map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{ position: 'relative' }}>
                            {/* <label style={{ whiteSpace: 'nowrap', fontSize:'1.5rem', display: 'block', marginBottom: '5px' }}>Enter company name:</label> */}
                            <input 
                                type="text"
                                value={inputCompanyName}
                                onChange={(e) => onChangeInputCompany(e.target.value)}
                                placeholder="e.g: enter company name A, B... (minimum 3 characters)"
                                className="filter-input"
                                style={{ width: '550px' }}
                            />
                            
                            {/* Danh sách gợi ý công ty */}
                            {listSuggestCompany.length > 0 && (
                                <div style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    backgroundColor: '#fff',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    zIndex: 100,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                }}>
                                    {renderSuggestCompany()}
                                </div>
                            )}
                        </div>

                        <button className="btn btn-primary" onClick={() => fetchBookingData('company')}>
                            🔍 Find Data
                        </button>
                    </div>
                </div>
            )}

            {/* Mail Search Tab */}
            {activeTab === 'mail' && (
                <div className="search-tab-section">
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        gap: '15px', 
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        padding: '4px'
                    }}>
                        <div className="filter-group">
                            <label>Year:</label>
                            <select value={mailYear} onChange={(e) => setMailYear(Number(e.target.value))}>
                                {years.map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </select>
                        </div>

                        {/* <label style={{ whiteSpace: 'nowrap' }}>Enter email:</label> */}
                        <input 
                            type="text"
                            value={mailValue}
                            onChange={(e) => setMailValue(e.target.value)}
                            placeholder="Input mail address mail domain / full main ..."
                            className="filter-input"
                            style={{ width: '350px' }}
                        />

                        <label className="accuracy-checkbox-label" style={{ 
                            alignItems: 'center', 
                            gap: '6px', 
                            cursor: 'pointer', 
                            whiteSpace: 'nowrap'
                        }}>
                            <input 
                                type="checkbox" 
                                checked={mailIsExactMatch} 
                                onChange={(e) => setMailIsExactMatch(e.target.checked)} 
                            />
                            Accuracy
                        </label>

                        <button className="btn btn-primary" onClick={() => fetchBookingData('mail')}>
                            🔍 Find Data
                        </button>
                    </div>
                </div>
            )}

            {/* Line Search Tab */}
            {(activeTab === 'line' || activeTab === "custom") && (
                <div className="search-tab-section">
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        gap: '15px', 
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        padding: '4px'
                    }}>
                        <div className="filter-group">
                            <label>Year:</label>
                            <select value={lineYear} onChange={(e) => setLineYear(Number(e.target.value))}>
                                {years.map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </select>
                        </div>

                        <div className="filter-group">
                            <label>Month:</label>
                            <select value={lineMonth} onChange={(e) => {
                                const val = e.target.value;
                                setLineMonth(val === "All Month" ? "All Month" : Number(val));
                            }}>
                                {months.map(month => (
                                    <option key={month} value={month}>
                                        Month {month.toString().padStart(2, '0')}
                                    </option>
                                ))}
                                <option key={"all Month"} value = "All Month" >
                                    All Month
                                </option>
                            </select>
                        </div>

                        {activeTab === "custom" && (
                            <>
                                 <label style={{ whiteSpace: 'nowrap', fontSize: '1.5rem' }}>Search keyword:</label>
                                <input 
                                    type="text"
                                    value={customValue}
                                    onChange={(e) => setCustomValue(e.target.value)}
                                    placeholder="e.g: company name, email, channel, room..."
                                    className="filter-input"
                                    style={{ width: '350px' }}
                                />
                            </>
                        )}

                        <button className="btn btn-primary" onClick={() => {
                            fetchBookingData(activeTab);
                            setSelectedOTAChannel("ALL")
                            setSelectedMultiBranch("ALL")
                        }}>
                            🔍 Find Data
                        </button>
                    </div>
                </div>
            )}

            {/* OTA Search Tab */}
            {activeTab === 'ota' && (
                <div className="search-tab-section">
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        gap: '15px', 
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        padding: '4px'
                    }}>
                        <div className="filter-group">
                            <label>Year:</label>
                            <select value={otaYear} onChange={(e) => setOtaYear(Number(e.target.value))}>
                                {years.map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </select>
                        </div>

                        <div className="filter-group">
                            <label>Month:</label>
                            <select value={otaMonth} onChange={(e) => {
                                const val = e.target.value;
                                setOtaMonth(val === "All Month" ? "All Month" : Number(val));
                            }}>
                                {months.map(month => (
                                    <option key={month} value={month}>
                                        Month {month.toString().padStart(2, '0')}
                                    </option>
                                ))}
                                <option key={"All Month"} value = "All Month">
                                    All Month
                                </option>
                            </select>
                        </div>

                        <button className="btn btn-primary" onClick={() => {
                            fetchBookingData('ota');
                            setSelectedOTAChannel("ALL");
                            setSelectedMultiBranch("ALL");
                        }}>
                            🔍 Find Data
                        </button>
                    </div>
                </div>
            )}

                        {/* Custom Search Tab */}
            {activeTab === 'color' && (
                <div className="search-tab-section">
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        gap: '15px', 
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        padding: '4px'
                    }}>
                        <div className="filter-group">
                            <label>Year:</label>
                            <select value={colorYear} onChange={(e) => setColorYear(Number(e.target.value))}>
                                {years.map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </select>
                        </div>

                        <div className="filter-group">
                            <label>Month:</label>
                            <select value={colorMonth} onChange={(e) => setColorMonth(Number(e.target.value))}>
                                {months.map(month => (
                                    <option key={month} value={month}>
                                        Month {month.toString().padStart(2, '0')}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <label style={{ whiteSpace: 'nowrap', fontSize: '1.5rem' }}>Search keyword:</label>
                        {/* <input 
                            type="text"
                            value={customValue}
                            onChange={(e) => setCustomValue(e.target.value)}
                            placeholder="e.g: company name, email, channel, room..."
                            className="filter-input"
                            style={{ width: '350px' }}
                        /> */}

                        <div style={{ position: 'relative', }}>
                            <div style={{
                                width: '70px',
                                backgroundColor: color,
                                cursor:'pointer',
                                height: '100%'
                            }}
                            onClick={() => setOpenColor(!openColor)}
                            >{color}</div>

                            {openColor && <div
                                style={{
                                    position: "absolute",
                                    backgroundColor: 'white',
                                  // bottom: '24px',
                                    top: '20px',
                                    width: '375px',
                                    height: '275px' ,
                                    zIndex: '999',
                                    fontSize: '1.4rem',
                                    padding: '8px',
                                    border: '1px solid aqua'
                                }}>
                                {renderTeamColor()}

                                <div className="d-flex justify-content-between">
                                    {/* <button className="btn btn-danger mt-1"
                                        onClick={() => checkColor("cancel")}>Cancel</button> */}
                                    <div className="d-flex">
                                        <div className="mr-1">Color hex:</div>
                                        <input className="mr-3"
                                            //onChange={e => onChangeColor(e.target.value)}
                                            //onBlur={() => checkColor("check")}
                                            value={color}
                                            maxLength={7}
                                            style={{ width: '80px' }}
                                        />
                                    </div>
                                </div>
                            </div>}
                        </div>

                        <button className="btn btn-primary" onClick={() => fetchBookingData('color')}>
                            🔍 Find Data
                        </button>
                    </div>
                </div>
            )}

            {/* Custom Search Tab */}
            {activeTab === 'custom2' && (
                <div className="search-tab-section">
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        gap: '15px', 
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        padding: '4px'
                    }}>
                        <div className="filter-group">
                            <label>Year:</label>
                            <select value={customYear} onChange={(e) => setCustomYear(Number(e.target.value))}>
                                {years.map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </select>
                        </div>

                        <div className="filter-group">
                            <label>Month:</label>
                            <select value={customMonth} onChange={(e) => setCustomMonth(Number(e.target.value))}>
                                {months.map(month => (
                                    <option key={month} value={month}>
                                        Month {month.toString().padStart(2, '0')}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <label style={{ whiteSpace: 'nowrap', fontSize: '1.5rem' }}>Search keyword:</label>
                        <input 
                            type="text"
                            value={customValue}
                            onChange={(e) => setCustomValue(e.target.value)}
                            placeholder="e.g: company name, email, channel, room..."
                            className="filter-input"
                            style={{ width: '350px' }}
                        />

                        <button className="btn btn-primary" onClick={() => fetchBookingData('custom')}>
                            🔍 Find Data
                        </button>
                    </div>
                </div>
            )}

            {/* Loading & Error */}
            {loading && <div className="loading">⏳ Loading data...</div>}
            {error && <div className="error">❌ {error}</div>}

            {!loading && !error && (activeTab !== "line" && activeTab !== 'custom' && activeTab !== 'ota')&&  (
              
                <div style={{ padding: '4px' }}>
                            <h2 style={{ marginBottom: '15px' }}>Booking List</h2>
                            <div>Branch: {branchID}</div>
                            <div style={{ 
                                overflowX: 'auto', 
                                overflowY: 'auto',
                                maxHeight: '600px',
                                border: '1px solid #ddd',
                                borderRadius: '6px'
                            }}>
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                fontFamily: 'Arial, sans-serif',
                                fontSize: '14px',
                                textAlign: 'left'
                            }}>
                                <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                    <tr style={{ backgroundColor: '#f4f4f4', borderBottom: '2px solid #ddd' }}>
                                        <th style={thStyle}>No.</th>
                                        <th style={thStyle}>Booking ID</th>
                                        <th style={thStyle}>Branch</th>
                                        <th style={thStyle}>Customer Name</th>
                                        <th style={thStyle}>Email</th>
                                        <th style={thStyle}>{activeTab === "ota" ? "OTA Name": "Payment"}</th>
                                        <th style={thStyle}>Check-in</th>
                                        <th style={thStyle}>Check-out</th>
                                        <th style={thStyle}>Nights</th>
                                        <th style={thStyle}>Room</th>
                                        <th style={thStyle}>Price</th>
                                        <th style={thStyle}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bookingData.map((item, index) => (
                                        <tr key={item.boooking_id} style={trStyle} className="table-row">
                                            <td style={tdStyle}>{index + 1}</td>
                                            <td style={{ ...tdStyle, fontWeight: 'bold', color: '#555' }}>{item.boooking_id}</td>
                                            <td style={tdStyle}>{item.branch}</td>
                                            <td style={{ ...tdStyle, fontWeight: '500' }}>{item.name}</td>
                                            <td style={tdStyle}>{item.mail}</td>
                                            <td style={tdStyle}>
                                                <span style={{
                                                    backgroundColor: '#e3f2fd',
                                                    color: '#0d47a1',
                                                    padding: '3px 8px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    textTransform: 'uppercase'
                                                }}>
                                                    {activeTab === "ota" ? item.otaName : item.payment}
                                                </span>
                                            </td>
                                            <td style={tdStyle}>{item.checkin}</td>
                                            <td style={tdStyle}>{item.checkout}</td>
                                            <td style={{ ...tdStyle, textAlign: 'center' }}>{item.nights}</td>
                                            <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 'bold' }}>{item.roomSelect}</td>
                                            <td style={{ ...tdStyle, color: '#d32f2f', fontWeight: 'bold' }}>{formatPrice(item.price)}</td>
                                            <td style={tdStyle}>
                                                <a 
                                                    href={item.link} 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        color: '#1976d2',
                                                        textDecoration: 'none',
                                                        fontWeight: '500'
                                                    }}
                                                > Detail </a>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                    </div>
                </div>
            )}

            {
                !loading && !error && (activeTab === "line" || activeTab === 'custom' || activeTab === 'ota') && <div>
                { (role === 6 || role === 7) && (
                    <><div style={{ 
                        display: 'flex', 
                        gap: '10px', 
                        marginBottom: '15px',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        padding: '10px',
                        backgroundColor: '#f9f9f9',
                        borderRadius: '6px'
                    }}>
                        {listBranch.length > 0 && <label style={{ fontWeight: '600', fontSize: '14px' }}>Filter by branch:</label>}
                        {listBranch.length > 0 && <button
                            onClick={() => {
                                setSelectedMultiBranch('ALL');
                                if(activeTab === "ota") setSubBookingData(summaryOTABranch[0]);
                            }}
                            style={{
                                padding: '8px 12px',
                                backgroundColor: selectedMultiBranch === 'ALL' ? '#1976d2' : '#e0e0e0',
                                color: selectedMultiBranch === 'ALL' ? '#fff' : '#333',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontWeight: selectedMultiBranch === 'ALL' ? '600' : '500',
                                fontSize: '13px'
                            }}
                        >All Branches</button>}

                        {listBranch.length > 0 && listBranch.map((branchIDOnList, index) => (
                            branchIDOnList !== "ALL" && (
                                <button
                                    key={index}
                                    onClick={() => {         
                                        setSelectedMultiBranch(index);
                                        if(activeTab === "ota") setSubBookingData(summaryOTABranch[index]);
                                    }}
                                    style={{
                                        padding: '8px 12px',
                                        backgroundColor: selectedMultiBranch === index ? '#1976d2' : '#e0e0e0',
                                        color: selectedMultiBranch === index ? '#fff' : '#333',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontWeight: selectedMultiBranch === index ? '600' : '500',
                                        fontSize: '13px',
                                        textTransform: 'capitalize',
                                    }}
                                > {coverBranchIDToFullName(branchIDOnList)}</button>
                            )
                        ))}
                    </div>
                    </>
                )}
                {activeTab === "ota" && (
                    <div style={{ 
                        display: 'flex', 
                        gap: '10px', 
                        marginBottom: '15px',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        padding: '10px',
                        backgroundColor: '#f9f9f9',
                        borderRadius: '6px'
                    }}>
                        {listOTAType.length > 0 && <label style={{ fontWeight: '600', fontSize: '14px' }}>Filter by Channel:</label>}
                        {listOTAType.length > 0 && <button
                            onClick={() => setSelectedOTAChannel('ALL')}
                            style={{
                                padding: '8px 12px',
                                backgroundColor: selectedOTAChannel === 'ALL' ? '#1976d2' : '#e0e0e0',
                                color: selectedOTAChannel === 'ALL' ? '#fff' : '#333',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontWeight: selectedOTAChannel === 'ALL' ? '600' : '500',
                                fontSize: '13px'
                            }}
                        >
                            ALL
                        </button>}
                        {listOTAType.length > 0 && LIST_NAME_OTA.map(channel => (
                            <button
                                key={channel}
                                onClick={() => setSelectedOTAChannel(channel)}
                                style={{
                                    padding: '8px 12px',
                                    backgroundColor: selectedOTAChannel === channel ? '#1976d2' : '#e0e0e0',
                                    color: selectedOTAChannel === channel ? '#fff' : '#333',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontWeight: selectedOTAChannel === channel ? '600' : '500',
                                    fontSize: '13px',
                                    textTransform: 'capitalize',
                                    display: listOTAType.includes(channel) ? 'inline-block' : 'none'
                                }}
                            >
                                {channel}
                            </button>
                        ))}
                    </div>
                )}
                {(activeTab === "line" || activeTab === "custom") && bookingData.length >0 && <div className='d-flex'>
                    {renderTotalBookingLine()}
                            {/* <h3>Total Booking : {subBookingData[0]?.totalBooking || 0} ({subBookingData[0]?.totalNight || 0} Nights)</h3> */}
                </div>}
                <div style={{ 
                    overflowX: 'auto', 
                    overflowY: 'auto',
                    maxHeight: '600px',
                    border: '1px solid #e0e0e0', 
                    borderRadius: '6px', 
                    display: 'flex',
                }}>
                    {activeTab === "ota" && bookingData.length > 0 && <div className='mr-3' style={{position:'fixed'}}>
                        <div>
                            {
                                 subBookingData.length > 0 && (
                                    <table style={{ borderCollapse: 'collapse', fontSize: '14px', textAlign: 'left', marginBottom: '20px', width: '150px' }}>
                                        <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                            <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '2px solid #ddd' }}>
                                                <th style={thStyle}>Channel</th>
                                                <th style={thStyle}>Bookings</th>
                                                <th style={thStyle}>Nights</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{background: "#f5f5f5"}}>
                                            {subBookingData.map((item, index) => (
                                                <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                                                    <td style={{...tdStyle, background: item._id === "Total" ? "yellow" : "unset"}}>{item._id.toUpperCase()}</td>
                                                    <td style={{...tdStyle, background: item._id === "Total" ? "yellow" : "unset"}}>{item.totalBooking}</td>
                                                    <td style={{...tdStyle, background: item._id === "Total" ? "yellow" : "unset"}}>{item.totalNight}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )
                            }
                        </div>
                    </div>}

                    <table style={{ 
                            width: '100%', 
                            borderCollapse: 'collapse', 
                            fontSize: '14px', 
                            textAlign: 'left', 
                            marginLeft: activeTab === "ota" ? '265px' : 'unset'
                        }}>
                            <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '2px solid #ddd' }}>
                                    <th style={thStyle}>No.</th>
                                    <th style={thStyle}>Booking ID</th>
                                    <th style={thStyle}>Room</th>
                                    <th style={thStyle}>{activeTab === "ota" ? "OTA name": "Discount"}</th>
                                    <th style={thStyle}>Check-in</th>
                                    <th style={thStyle}>Check-out</th>
                                    <th style={{ ...thStyle, textAlign: 'center' }}>Overlap Nights</th>
                                    <th style={thStyle}>Requests / Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookingData.filter(item => {
                                   // console.log("item", item)
                                        if (activeTab === "ota" || activeTab === "line" || activeTab === "custom") {
                                            // Filter by channel
                                            if (selectedOTAChannel !== 'ALL' && (!item.otaName || item.otaName.toLowerCase() !== selectedOTAChannel.toLowerCase())) {
                                                return false;
                                            }
                                            // Filter by branch
                                            if (selectedMultiBranch !== 'ALL') {
                                                console.log("item.booking_id.", item)
                                                const branchToFilter = listBranch[selectedMultiBranch];
                                                if (Number(item.booking_id.slice(0,2)) !== branchToFilter) {
                                                    return false;
                                                }
                                            }
                                            return true;
                                        }
                                        return true;
                                    })
                                    .map((item, index) => (
                                    <tr key={item.booking_id} style={{ borderBottom: '1px solid #eee' }}>
                                        <td style={tdStyle}>{index + 1}</td>
                                        <td style={{ ...tdStyle, fontWeight: 'bold', color: '#1976d2' }}>{item.booking_id}</td>
                                        <td style={{ ...tdStyle, fontWeight: '600' }}>{item.roomSelect}</td>
                                        <td style={tdStyle}>
                                            <span style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', padding: '2px 6px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>
                                                {activeTab === "ota" ? item.otaName.toUpperCase() : item.discount + "% OFF"}
                                            </span>
                                        </td>
                                        <td style={tdStyle}>{formatDate(item.checkin)}</td>
                                        <td style={tdStyle}>{formatDate(item.checkout)}</td>
                                        <td style={{ 
                                            ...tdStyle, 
                                            textAlign: 'center', 
                                            color: item.overlapNights > 0 ? '#d32f2f' : '#666',
                                            fontWeight: item.overlapNights > 0 ? 'bold' : 'normal'
                                        }}>
                                            {item.overlapNights}
                                        </td>
                                        <td style={{ ...tdStyle, color: '#555', fontSize: '13px', whiteSpace: 'pre-line', maxWidth: '400px' }}>
                                            {item.request1}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                </div>
                </div>
            }

            {bookingData.length > 0 && <div style={{ display: 'flex', gap: '10px' }}>
                {/* Nút Download CSV */}
                <button onClick={exportToCSV} className='btn btn-primary'>
                    📥 Export CSV
                </button>
                    
                {/* Nút Download Excel thực tế (.xlsx) */}
                <button onClick={exportToExcel} className='btn btn-success' style={{ backgroundColor: '#28a745', borderColor: '#28a745' }}>
                    📊 Export Excel (.xlsx)
                </button>
            </div>}
        </div>
    );

};

export default StatisticsData;
